import React from 'react';
import { ToastsContainer } from '@periodica/ui-kit';
import { UseDeskProvider } from '@periodica/usedesk';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { AlertProvider } from './src/hooks/useAlertContext';

const queryClient = new QueryClient();

export default function ({ element }) {
  return (
    <QueryClientProvider client={queryClient}>
      <UseDeskProvider>
        <AlertProvider>
          {element}
          <ToastsContainer />
        </AlertProvider>
      </UseDeskProvider>
    </QueryClientProvider>
  );
}
